// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mixed-input input.el-input__inner:focus{border-color:#dbdfe6}.match-settings label.el-form-item__label{padding:0 5px 0 0}.match-settings .el-form-item__error{padding-top:.3rem;position:unset}.match-Setting-Loading{border:1px solid #ccc;padding:1rem;height:825px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
